import * as React from 'react';
import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  LinearProgress,
  Typography
} from "@mui/material";
import dayjs from "dayjs";

interface ExportDialogsProps {
  showExportWarning: boolean;
  onCloseExportWarning: () => void;
  showExportConfirmation: boolean;
  onCloseExportConfirmation: () => void;
  startExport: () => void;
  isExporting: boolean;
  plotQueryProps: { inState: string[] };
  monthLabels: any[];
  totalMonths: number;
  exportProgress: number;
}

const ExportDialogs: React.FC<ExportDialogsProps> = ({
                                                       showExportWarning,
                                                       onCloseExportWarning,
                                                       showExportConfirmation,
                                                       onCloseExportConfirmation,
                                                       startExport,
                                                       isExporting,
                                                       plotQueryProps,
                                                       monthLabels,
                                                       totalMonths,
                                                       exportProgress
                                                     }) => {
  return (
    <>
      {showExportWarning &&
          <Alert severity="warning" onClose={onCloseExportWarning}>
              Exporting data for all states is not supported. Please select a specific state.
          </Alert>
      }
      <Dialog open={showExportConfirmation} onClose={onCloseExportConfirmation}>
        <DialogTitle>Confirm Export</DialogTitle>
        <DialogContent>
          <Typography>
            You are about to output scenario data for state: {plotQueryProps.inState.join(', ')} from {monthLabels?.[0] ? dayjs(monthLabels[0], 'DD/MM/YYYY').format('MMM YYYY') : ''} to {monthLabels?.[monthLabels.length - 1] ? dayjs(monthLabels[monthLabels.length - 1], 'DD/MM/YYYY').format('MMM YYYY') : ''}.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={onCloseExportConfirmation}>No</Button>
          <Button onClick={startExport}>Yes</Button>
        </DialogActions>
      </Dialog>
      <Dialog open={isExporting}>
        <DialogTitle>Exporting to CSV</DialogTitle>
        <Box sx={{ p: 2, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <CircularProgress sx={{ mb: 2 }}/>
          <Typography>Preparing your file. This may take a moment...</Typography>
          {totalMonths > 0 &&
              <Box sx={{ width: '100%', mt: 2 }}>
                  <LinearProgress variant="determinate" value={(exportProgress / totalMonths) * 100} />
                  <Typography variant="body2" color="text.secondary" sx={{mt: 1}} align="center">
                    {exportProgress} of {totalMonths} months processed.
                  </Typography>
              </Box>
          }
        </Box>
      </Dialog>
    </>
  );
};

export default ExportDialogs;
